import { API_ROOT } from '../../config/config'
import { doGet, doPut } from './utils'

// const API_ROOT = 'http://localhost:9016/api'

export const getFundManagerAudit = (id = '', projectversionId = '') => {
  const url = `${API_ROOT}/v1/audit/ia/get?id=${id}&projectversionId=${projectversionId}`
  return doGet(url)
}

export const saveFundManagerAudit = (request, id = '', isSaveDraft = false) => {
  const url = `${API_ROOT}/v1/audit/ia/approver/${id}?saveDraft=${isSaveDraft}`
  return doPut(url, request)
}
